module.exports = __webpack_public_path__ + "static/media/ivo_dal.26ad070.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/ivo_dal.mp3
// module id = 2M1N
// module chunks = 1